module.exports = __webpack_public_path__ + "media/images/av-logo-horizontal-48-0b4836ec01b4f007cbf4eac4bc1ed321.png";